// extracted by mini-css-extract-plugin
export var backBtn = "project-details-module--backBtn--HcvmA";
export var backChevron = "project-details-module--backChevron--2e3Vq";
export var details = "project-details-module--details--VKOxD";
export var imageContainer = "project-details-module--imageContainer--4QT6x";
export var projectMd = "project-details-module--projectMd--DAVx6";